import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: Routes.FORGOTTEN_PASSWORD,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/ForgottenPasswordContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'forgottenPassword', reducer: reducer.default })

    cb(null, module.default)
  }
})
